import Helper from './Helper';

class SideNav {
  constructor(config = {}) {
    const {
      headerRef,
    } = config;

    this.headerRef = headerRef;
    this.sidenav = document.querySelector('.sidenav');
    this.currentParentPage = document.querySelector('.menu__item--ancestor-active > .menu__link > .menu__link-text');
    this.currentParentPageLink = document.querySelector('.menu__item--ancestor-active.menu__item--has-children .menu__link--level-0');
    this.currentPage = document.querySelector('.menu__item--active > .menu__link > .menu__link-text');
    this.body = document.querySelector("body");

    if (!!this.sidenav) {
      this.titles = Array.prototype.slice.call(document.querySelectorAll('.ns-header-image, .ns-title-h2:not(.ns-title-h2--no-sidebar)'));

      if (this.titles.length > 1) {
        this.generateSideNav();
      }
    }
  }

  generateSideNav() {
    let html = '';
    let keyDots = 0;
    let keyTitles = 0;
    html += '<div class="sidenav__content-inner">'
    html += '<div class="sidenav__dots">'
    this.titles.forEach(d => {
      d.dataset.index = keyDots;
      html += '<a class="sidenav__link sidenav__link--dot" href="#' + keyDots + '" data-sidenav-dot="' + keyDots + '"><span class="sidenav__dot"></span></a>';
      keyDots++;
    });
    html += '</div>'
    html += '<div class="sidenav__content">'
    if (this.currentParentPage && this.currentPage) {
      html += '<div class="sidenav__main-title">' + `<a class="sidenav__main-title-link">${this.currentParentPage.innerHTML}</a>` + ' | ' + this.currentPage.innerHTML + '</div>'
    } else {
      html += '<div class="sidenav__main-title">&nbsp;</div>'
    }
    this.titles.forEach(t => {
      t.dataset.index = keyTitles;
      let titlesText = t.innerHTML;
      if (Helper.hasClass(t, 'ns-header-animation')) {
        titlesText = t.querySelector('.ns-title-h1').innerHTML;
      }
      html += '<a class="sidenav__link sidenav__link--text" href="#' + keyTitles + '"  data-sidenav-title="' + keyTitles + '"><span class="sidenav__text">' + titlesText + '</span></a>';
      keyTitles++;
    });
    html += '</div>'
    html += '</div>'

    this.sidenav.innerHTML = html;

    this.sideNavTextLinks = document.querySelectorAll('.sidenav__link--text');
    this.sideNavTextLinksArray = Array.prototype.slice.call(this.sideNavTextLinks);

    this.sideNavDotLinks = document.querySelectorAll('.sidenav__link--dot');
    this.sideNavDotLinksArray = Array.prototype.slice.call(this.sideNavDotLinks);

    this.sideNavLinks = document.querySelectorAll('.sidenav__link');
    this.sideNavLinksArray = Array.prototype.slice.call(this.sideNavLinks);

    this.sideNavDots = document.querySelector('.sidenav__dots');

    this.bindLinks();
    this.scrollSpy();
  }

  scrollSpy() {
    let lastIndex = 0;
    let lastScroll = 0;
    const maxIndex = this.sideNavLinksArray.length;
    let index = this.getIndex();
    this.setLinkActive(index);

    document.addEventListener('scroll', () => {
      if (window.scrollY > lastScroll) {
        //scrolling down
        if (index < maxIndex) {
          if (!!this.titles[index + 1] && Helper.isInViewport(this.titles[index + 1])) {
            index++;
          }
        }
      } else {
        //scrolling up
        if (index > 0) {
          if (!!this.titles[index - 1] && Helper.isInViewport(this.titles[index - 1])) {
            index--;
          }
        }
      }
      lastScroll = window.scrollY;
      if (index != lastIndex) {
        if (lastIndex !== false) {
          this.removeLinkActive(lastIndex);
        }
        this.setLinkActive(index);
        lastIndex = index;
      }
    });
  }

  setLinkActive(index) {
    const linkDot = this.sideNavDotLinksArray[index];
    const linkText = this.sideNavTextLinksArray[index];

    if (!linkDot.classList.contains('active')) linkDot.classList.add('active');
    if (!linkText.classList.contains('active')) linkText.classList.add('active');
  }

  removeLinkActive(index) {
    const linkDot = this.sideNavDotLinksArray[index];
    const linkText = this.sideNavTextLinksArray[index];
    if (linkDot.classList.contains('active')) linkDot.classList.remove('active');
    if (linkText.classList.contains('active')) linkText.classList.remove('active');
  }

  getIndex() {
    let index = 0;

    this.titles.forEach(t => {
      if (Helper.isInViewport(t)) {
        index = t.dataset.index;
        return index;
      }
    });
    return index;
  }

  bindLinks() {
    this.sideNavDots.addEventListener("mouseenter", (e) => {
      this.showSideNav();
    });

    this.sideNavLinksArray.forEach(el => {
      el.addEventListener("mouseenter", (e) => {
        this.hoverSync(el, 'hover');
      });

      el.addEventListener("mouseleave", (e) => {
        this.killHoverSync('hover');
      });

      el.addEventListener("click", (e) => {
        this.killHoverSync('active');
        this.hoverSync(el, 'active');
        e.preventDefault();
        this.scrollTo(this.titles[parseInt(el.getAttribute("href").replace('#', ''))]);
      });
    });

    this.sidenav.addEventListener("mouseleave", (e) => {
      this.hideSideNav();
    });


    if (this.headerRef) {
      const mainTitle = document.querySelector('.sidenav__main-title-link');
      if (mainTitle) {
        mainTitle.addEventListener('click', (e) => {
          e.preventDefault();
          this.headerRef.toggleSubmenu(this.currentParentPageLink);
        });
      }
    }
  }

  showSideNav() {
    Helper.addClass(this.sidenav, 'active');
    Helper.addClass(this.body, "sidenav-active");
  }

  hideSideNav() {
    Helper.removeClass(this.sidenav, 'active');
    Helper.removeClass(this.body, "sidenav-active");
  }

  hoverSync(el, className) {
    const indicator = Helper.hasClass(el, 'sidenav__link--dot');
    let index = indicator ? el.getAttribute('data-sidenav-dot') : el.getAttribute('data-sidenav-title');
    let otherAttributeName = indicator ? 'data-sidenav-title' : 'data-sidenav-dot';
    let otherArray = indicator ? this.sideNavTextLinksArray : this.sideNavDotLinksArray;

    Helper.addClass(el, className);

    otherArray.forEach(sideNavLink => {
      const otherIndex = sideNavLink.getAttribute(otherAttributeName);

      if (index === otherIndex) {
        Helper.addClass(sideNavLink, className);
      } else {
        Helper.removeClass(sideNavLink, className);
      }
    });
  }

  killHoverSync(className) {
    this.sideNavLinksArray.forEach(sideNavLink => {
      Helper.removeClass(sideNavLink, className);
    });
  }

  scrollTo(element) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: Helper.getRealOffsetTop(element) - 100
    });
  }

}

export default SideNav;
